import { Dialog, DialogContent, DialogTitle, DialogActions, FlexGrid, Typography, Button } from "@albo-ui/core";
import { AfbCompanyCardsProps } from "./types";
import cardImage from "../../../images/card.png";

const AfbCompanyCards = ({ open, content, onClose }: AfbCompanyCardsProps) => {
    return (
        content && <Dialog onClose={() => onClose("account")} open={open} >
            <DialogTitle>
                <Typography variant='h2'>Tarjetas de {content.customer.general.gname}</Typography>
            </DialogTitle>

            <DialogContent style={{padding: "0px"}}>
                <FlexGrid container spacing={2} fullWidth>
                    <FlexGrid item >
                        <img alt={"CardImage"} src={cardImage} style={{marginInline: "-16px", maxWidth: 220}} />
                    </FlexGrid>

                    <FlexGrid item style={{ marginTop: "25px"}} fullWidth>
                        <FlexGrid style={{ display: "grid" }}>
                            <Typography variant='smallTitle'style={{ color: "green" }}>
                                Tarjetas activadas
                            </Typography>
                            <b>{content.assigned}</b>
                        </FlexGrid>

                        <FlexGrid style={{ display: "grid", marginTop: "16px" }}>
                            <Typography variant='smallTitle'style={{ color: "red" }}>
                                Tarjetas por activar
                            </Typography>
                            <b>{content.unassigned}</b>
                        </FlexGrid>
                    </FlexGrid>
                </FlexGrid>
            </DialogContent>

            <DialogActions sx={{marginTop: "0px !important"}}>
                <Button onClick={() => onClose('cards')} size="normal">
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AfbCompanyCards;
